<template>
  <div class="home">
    <loginForm />
  </div>
</template>

<script>
// @ is an alias to /src
import loginForm from '@/components/auth/loginForm.vue';

export default {
    name: 'login',
    components: {
        loginForm
    }
};
</script>
